import { render, staticRenderFns } from "./JRadio.vue?vue&type=template&id=395f23ad&"
import script from "./JRadio.vue?vue&type=script&lang=js&"
export * from "./JRadio.vue?vue&type=script&lang=js&"
import style0 from "./JRadio.vue?vue&type=style&index=0&id=395f23ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports